import { EVENT_TYPE } from '@src/constants';
import { VOICE_PROVIDER } from '@src/constants/voice';

export const TRY_VOICE_ACTION = {
  PREVIEW: 'preview',
  USE: 'use',
  CONVERT: 'convert',
};

// Preview/use send one event per voice per SPA session, so their counts
// approximate the number of distinct voices a user tried. Convert sends one
// event per accepted synthesis request.
const SESSION_DEDUPED_ACTIONS = [
  TRY_VOICE_ACTION.PREVIEW,
  TRY_VOICE_ACTION.USE,
];
const trackedTryVoices = new Set();

export const trackTryVoice = ({ voice, action }) => {
  if (!voice?.code) return;

  if (voice.provider !== VOICE_PROVIDER.VBEE) return;

  if (SESSION_DEDUPED_ACTIONS.includes(action)) {
    const dedupeKey = `${voice.code}:${action}`;
    if (trackedTryVoices.has(dedupeKey)) return;
    trackedTryVoices.add(dedupeKey);
  }

  window.dataLayer.push({
    event: EVENT_TYPE.TRY_VOICE,
    voice_code: voice.code,
    voice_level: voice.level,
    action,
  });
};

// Block voice objects can be stale or partial (e.g. voiceCode changed without
// voice), so only a candidate matching the submitted code is trusted
export const pickSubmittedVoice = (voiceCode, candidates) =>
  candidates.find((candidate) => candidate?.code === voiceCode);
